<template>
  <div class="title-input">
    <div class="title" :class="{show: focused}">{{placeholder}}</div>
    <input type="text" class="input-warp" :value="value" :class="{active: focused}" :placeholder="placeholder" @focus.stop.prevent="focused=true" @blur="focused=false" @input="input">
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    value: String
  },
  data() {
    return {
      focused: false
    }
  },
  methods: {
    input(e) {
      if(e.target.value.length > 64) {
        e.target.value = e.target.value.substring(0, 64)
        Toast('不能超过64个字符')
      }
      this.$emit('input', e.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.title-input{
  height: 56px;
  padding: 0 20px;
  .title {
    font-size: 10px;
    color: #908ee4;
    height: 16px;
    line-height: 16px;
    visibility: hidden;
    &.show{
      visibility: visible;
    }
  }
  .input-warp {
    width: 100%;
    border-radius: 10px;
    padding-left: 8px;
    height: 40px;
    background-color: #f2f2f7;
  }
  .active {
    background-color: #deddf7;
  }
}
</style>